import React from 'react';
import {Container, NavDropdown, Nav, Navbar, Form, FormControl,Button, Row, Offcanvas } from 'react-bootstrap'
import $ from "jquery"
import { Link } from 'react-router-dom';
import "../stylesheets/style.css"
import "../js/main.js"
const Map = () => {



return(
<div className=''>

<div className='container'>


   <div class="row">
       <div class="col-md-6">
     <img className='img-fluid mapimage' src="/images/oakgrandeur2/frame4.jpg"/>
       </div>


       <div class="col-md-6 mobilerow">
       <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3939.6626258452025!2d7.4410077151575615!3d9.094465993475438!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104e0ab5d35fd273%3A0x10d7c83ca882362!2sPlatinum%20Mega%20Mall!5e0!3m2!1sen!2sng!4v1644415575724!5m2!1sen!2sng"
        width="100%"
        height="436"
        // style={{ borderTopRightRadius:"20px" ,  borderBottomRightRadius:"20px" }}
        allowfullscreen=""
        loading="lazy"
      
      ></iframe>
         
       </div>

    
   </div>
    </div>
</div>

)

};


export default Map ;